import treatAsUTC from '../../../common/utils/treatAsUTC';

const getLocalDateTime = () => {
  return treatAsUTC(new Date());
};

export default getLocalDateTime;
